import WithRender from "../../templates/tables/quantityTable.html";

export default WithRender({
  computed: {
    name: () => {
      return "Quantity";
    }
  }
});
